/**
 * Filter component
 * @author Carlos Romera <cromera@adasasistemas.com>
 */

// Library
import { useEffect, useRef, useState } from 'react';

// CSS Style for this module
import styles from './filter.module.scss';

interface FilterListItem {
	id: string | number;
	name: string;
}

/**
 * Interface for Filter props
 */
interface FilterProps {
	/** list of item to be filter */
	list: FilterListItem[];
	/** placeholder for the text input */
	placeholder: string;
}

/**
 * Filter generic component
 * @param {FilterProps} Prop
 * @returns  an text input element that filter items within list provided
 */
export const Filter = ({ list, placeholder }: FilterProps) => {
	const [searchText, setSearchText] = useState('');
	const [filteredlist, setFilteredlist] = useState(list);
	const [listItems] = useState(list);
	const inputRef = useRef(null);

	useEffect(() => {
		const filteredList = listItems.filter(item => {
			const stringLowerCase = `${item.name}`.toLowerCase();
			return stringLowerCase.indexOf(searchText.toLowerCase()) > -1 && searchText;
		});
		setFilteredlist(filteredList);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchText]);

	const onKeyUpHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
		setSearchText((e.target as HTMLInputElement).value);
	};
	return (
		<div className={styles.wrapper}>
			<input
				className={styles.filterInput}
				type="text"
				placeholder={placeholder}
				ref={inputRef}
				defaultValue={searchText}
				onKeyUp={onKeyUpHandler}
			/>
			<ul className={styles.filterList}>
				{filteredlist.map(itemList => {
					return (
						<li className={styles.filterListItem} key={itemList.id}>
							{itemList.name}
						</li>
					);
				})}
			</ul>
		</div>
	);
};
